import * as Apollo from '@apollo/client';
import { gql } from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  DateTime: any;
  JSON: any;
};

export type Address = {
  __typename?: 'Address';
  city: Scalars['String'];
  complement?: Maybe<Scalars['String']>;
  country: Scalars['String'];
  created_at: Scalars['DateTime'];
  id: Scalars['ID'];
  neighborhood: Scalars['String'];
  persons: Person;
  state: Scalars['String'];
  street: Scalars['String'];
  street_number: Scalars['String'];
  updated_at: Scalars['DateTime'];
  zipcode: Scalars['String'];
};

export type AddressInput = {
  __typename?: 'AddressInput';
  city: Scalars['String'];
  complement: Scalars['String'];
  country: Scalars['String'];
  created_at: Scalars['DateTime'];
  id: Scalars['Int'];
  neighborhood: Scalars['String'];
  state: Scalars['String'];
  street: Scalars['String'];
  street_number: Scalars['String'];
  updated_at: Scalars['DateTime'];
  zipcode: Scalars['String'];
};

/** Dados de cada assinatura para o PDF. */
export type AssinaturaInput = {
  /** Algoritmo de hash utilizado na assinatura. Exemplo: 'SHA256' */
  algoritmoHash: Scalars['String'];
  /** Lista de hashes das assinaturas. Exemplo: ['hash1', 'hash2'] */
  hashes: Array<Scalars['String']>;
  /** Nonce da assinatura. Exemplo: 'nonceAssinatura456' */
  nonce: Scalars['String'];
};

/** Assinatura inicializada para PDF. */
export type AssinaturasInicializadasType = {
  __typename?: 'AssinaturasInicializadasType';
  /** Resumo da mensagem (hash). Exemplo: 'a1b2c3d4...' */
  messageDigest: Scalars['String'];
  /** Nonce da assinatura inicializada. Exemplo: 'nonceAssinatura123' */
  nonce: Scalars['String'];
};

/** Assinatura para PDF. */
export type AssinaturasType = {
  __typename?: 'AssinaturasType';
  /** Algoritmo de hash utilizado na assinatura. Exemplo: 'SHA256' */
  algoritmoHash: Scalars['String'];
  /** Lista de hashes das assinaturas. Exemplo: ['hash1', 'hash2'] */
  hashes: Array<Scalars['String']>;
  /** Nonce da assinatura. Exemplo: 'nonceAssinatura456' */
  nonce: Scalars['String'];
};

export type Bonus = {
  __typename?: 'Bonus';
  bonusCredit: Scalars['Float'];
  description?: Maybe<Scalars['String']>;
  entity: Scalars['String'];
  id: Scalars['ID'];
  label: Scalars['String'];
  limitBonusCredit?: Maybe<Scalars['Float']>;
  products?: Maybe<Product>;
  quantity: Scalars['Float'];
  recommend: Scalars['Boolean'];
  score: Scalars['Float'];
};

/** Resposta da inicialização de assinatura PDF via BrySign. */
export type BrysignInitResponse = {
  __typename?: 'BrysignInitResponse';
  /** Algoritmo de hash utilizado. Exemplo: 'SHA256' */
  algoritmoHash: Scalars['String'];
  /** Lista de assinaturas. */
  assinaturas?: Maybe<Array<AssinaturasType>>;
  /** Lista de assinaturas inicializadas. */
  assinaturasInicializadas?: Maybe<Array<AssinaturasInicializadasType>>;
  /** Formato dos dados de entrada. Exemplo: 'PDF' */
  formatoDadosEntrada: Scalars['String'];
  /** Formato dos dados de saída. Exemplo: 'PDF' */
  formatoDadosSaida: Scalars['String'];
  /** Valor do nonce para a operação. Exemplo: 'abc123nonce' */
  nonce: Scalars['String'];
};

/** Dados necessários para solicitar assinatura PDF PADES via BrySign. */
export type BrysignSignPdfPadesInput = {
  /** Lista de assinaturas a serem realizadas. */
  assinaturas: Array<AssinaturaInput>;
  /** Lista de informações dos certificados para assinatura. Exemplo: [{ nonce: 'nonce1', musicId: 1, title: 'Música 1' }] */
  certsInfo: Array<DownloadCerts>;
  /** Formato dos dados de entrada. Exemplo: 'PDF' */
  formatoDadosEntrada: Scalars['String'];
  /** Formato dos dados de saída. Exemplo: 'PDF' */
  formatoDadosSaida: Scalars['String'];
  /** Nonce da operação. Exemplo: 'nonceOperacao123' */
  nonce: Scalars['String'];
};

/** Dados necessários para solicitar assinatura CADES via BrySign. */
export type BrysignSignatureCadesInput = {
  /** Lista de IDs das músicas para assinatura. Exemplo: [1, 2, 3] */
  music_ids: Array<Scalars['Int']>;
};

export type Categories = {
  __typename?: 'Categories';
  contacts: Array<Contact>;
  created_at?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  files: Array<File>;
  id: Scalars['ID'];
  musical_genres: Array<VideoGenre>;
  musical_styles: Array<MusicalStyle>;
  name: Scalars['String'];
  table_name: Scalars['String'];
  updated_at?: Maybe<Scalars['DateTime']>;
};

export type Certificate = {
  __typename?: 'Certificate';
  certificate_file_id?: Maybe<Scalars['Float']>;
  created_At?: Maybe<Scalars['DateTime']>;
  documentId?: Maybe<Scalars['Float']>;
  documentKey: Scalars['String'];
  files?: Maybe<File>;
  hashSHA256?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isActive: Scalars['Boolean'];
  key: Scalars['String'];
  music?: Maybe<Music>;
  signUrl?: Maybe<Scalars['String']>;
  signed: Scalars['Boolean'];
  signerId?: Maybe<Scalars['Float']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  uploadId?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** Informações de cada certificado utilizado na operação. */
export type CertsInfo = {
  __typename?: 'CertsInfo';
  /** ID da música associada ao certificado. Exemplo: 42 */
  musicId: Scalars['Int'];
  /** Nonce associado ao certificado. Exemplo: 'nonceCertificado123' */
  nonce: Scalars['String'];
  /** Título da música associada ao certificado. Exemplo: 'Minha Música Sertaneja' */
  title: Scalars['String'];
};

/** Dados para redefinir a senha via token de recuperação enviado ao email do usuário. */
export type ChangeForgotPasswordByTokenInput = {
  /** Nova senha do usuário. Mínimo 8 caracteres, letras e números. Exemplo: 'senhaNova123' */
  password: Scalars['String'];
  /** Token de recuperação enviado ao email do usuário. Exemplo: 'abc123token' */
  token: Scalars['String'];
};

/** Dados necessários para alterar a senha do usuário autenticado. */
export type ChangePasswordInput = {
  /** Nova senha do usuário. Mínimo 8 caracteres, letras e números. Exemplo: 'senhaNova456' */
  newPassword: Scalars['String'];
  /** Senha atual do usuário. Exemplo: 'senhaAntiga123' */
  password: Scalars['String'];
};

export type ChargeOrder = {
  items: Array<Items>;
};

export type Comment = {
  __typename?: 'Comment';
  created_At?: Maybe<Scalars['DateTime']>;
  entity: Scalars['String'];
  entity_id: Scalars['Float'];
  hide: Scalars['Boolean'];
  id: Scalars['ID'];
  message: Scalars['String'];
  updated_at?: Maybe<Scalars['DateTime']>;
  users: User;
};

/** Dados necessários para confirmação de cadastro do usuário. */
export type ConfirmUserInput = {
  /** Token de confirmação enviado ao usuário email. Exemplo: 'abc123token' */
  tokenId: Scalars['String'];
};

/** Dados necessários para confirmação de cadastro do usuário. */
export type ConfirmUserResponseInput = {
  __typename?: 'ConfirmUserResponseInput';
  /** Mensagem de confirmação do cadastro do usuário. */
  message: Scalars['String'];
  /** Dados do usuário confirmado. */
  user: UserConfirmed;
};

export type Contact = {
  __typename?: 'Contact';
  categories?: Maybe<Categories>;
  created_At?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  number: Scalars['String'];
  persons: Person;
  updated_at?: Maybe<Scalars['DateTime']>;
};

export type ContactInput = {
  __typename?: 'ContactInput';
  created_at: Scalars['DateTime'];
  id: Scalars['Int'];
  name: Scalars['String'];
  number: Scalars['String'];
  updated_at: Scalars['DateTime'];
};

export type CreateChargeInput = {
  api_payment?: InputMaybe<Scalars['String']>;
  creditCard?: InputMaybe<Scalars['JSON']>;
  holder?: InputMaybe<Scalars['Boolean']>;
  installments?: InputMaybe<Scalars['Float']>;
  ip?: InputMaybe<Scalars['String']>;
  order: ChargeOrder;
  payment_method: Scalars['String'];
  voucherId?: InputMaybe<Scalars['Float']>;
};

export type CreateChargeResponseDto = {
  __typename?: 'CreateChargeResponseDto';
  charge: Scalars['JSON'];
  created_at?: Maybe<Scalars['String']>;
  key: Scalars['String'];
  meta?: Maybe<Meta>;
  payment?: Maybe<PaymentOutput>;
  status_id?: Maybe<Scalars['Float']>;
  total?: Maybe<Scalars['String']>;
  voucher_id?: Maybe<Scalars['Float']>;
};

/** Dados necessários para iniciar a assinatura PADES via BrySign. */
export type CreateInitPadesInput = {
  /** Certificado digital em formato string. Exemplo: 'MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8A...' */
  certificate: Scalars['String'];
  /** Lista de IDs das músicas para assinatura. Exemplo: [1, 2, 3] */
  musicIds: Array<Scalars['Int']>;
};

/** Dados necessários para criar uma nova música. */
export type CreateMusicInput = {
  /** Informações do(s) coautor(es) da música. Exemplo: [{ id: 2, name: 'Maria', cpf: '09876543211' }] */
  co_author?: InputMaybe<Array<InterpreterOrCoauthor>>;
  /** Informações do(s) intérprete(s) da música. Exemplo: [{ id: 1, name: 'João', cpf: '12345678900' }] */
  interpreter?: InputMaybe<Array<InterpreterOrCoauthor>>;
  /** Letra da música em formato de array de strings. Exemplo: ['Primeira linha da letra', 'Segunda linha da letra'] */
  letter: Scalars['JSON'];
  /** ID do arquivo de música associado. Exemplo: 123 */
  music_file_id?: InputMaybe<Scalars['Int']>;
  /** ID do estilo musical. Exemplo: 76 */
  styles: Scalars['Int'];
  /** Título da música. Exemplo: 'Minha Canção Sertaneja' */
  title: Scalars['String'];
};

/** Dados necessários para registrar um novo usuário. */
export type CreateUserInput = {
  /** Confirmação da senha. Deve ser igual à senha informada. Exemplo: 'senhaSegura123' */
  confirmPassword: Scalars['String'];
  /** Contato do usuário. Mínimo 8 e máximo 14 caracteres. Exemplo: '85999999999' */
  contact: Scalars['String'];
  /** E-mail do usuário. Exemplo: 'usuario@email.com' */
  email: Scalars['String'];
  /** Apelido do usuário. Exemplo: 'Rafa123' */
  nickname: Scalars['String'];
  /** Senha do usuário. Mínimo 8 caracteres, letras e números. Exemplo: 'senhaSegura123' */
  password: Scalars['String'];
  /** Confirmação de aceite dos termos de uso. Exemplo: true */
  terms: Scalars['Boolean'];
};

export type CreditCard = {
  __typename?: 'CreditCard';
  brand?: Maybe<Scalars['String']>;
  card_id?: Maybe<Scalars['String']>;
  created_At?: Maybe<Scalars['DateTime']>;
  expiration_date?: Maybe<Scalars['String']>;
  holder_name?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  number?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  users?: Maybe<User>;
};

/** Informações de cada documento assinado. */
export type DocumentosType = {
  __typename?: 'DocumentosType';
  /** Hash do documento assinado. Exemplo: 'a1b2c3d4...' */
  hash: Scalars['String'];
  /** Lista de links para download ou visualização do documento assinado. */
  links: Array<LinkType>;
  /** Nome do arquivo do documento assinado. Exemplo: 'musica-assinada.pdf' */
  nomeArquivo: Scalars['String'];
  /** Nonce do documento assinado. Exemplo: 'nonceDocumento789' */
  nonce: Scalars['String'];
};

/** Informações de cada certificado para assinatura. */
export type DownloadCerts = {
  /** ID da música associada ao certificado. Exemplo: 42 */
  musicId: Scalars['Float'];
  /** Nonce associado ao certificado. Exemplo: 'nonceCertificado123' */
  nonce: Scalars['String'];
  /** Título da música associada ao certificado. Exemplo: 'Minha Música Sertaneja' */
  title: Scalars['String'];
};

export type File = {
  __typename?: 'File';
  categories?: Maybe<Categories>;
  certificates?: Maybe<Certificate>;
  created_At?: Maybe<Scalars['DateTime']>;
  disk?: Maybe<Scalars['String']>;
  extension?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  music: Array<Music>;
  name?: Maybe<Scalars['String']>;
  original_name?: Maybe<Scalars['String']>;
  path?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['Float']>;
  type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  users: Array<User>;
  videos: Array<Video>;
};

/** Dados para consulta de múltiplas músicas, permitindo filtros e paginação. */
export type FindManyMusicAdminInput = {
  /** Data de fim para filtro das músicas. Exemplo: '2024-06-30' */
  dateFim?: InputMaybe<Scalars['String']>;
  /** Data de início para filtro das músicas. Exemplo: '2024-06-01' */
  dateInicio?: InputMaybe<Scalars['String']>;
  /** ID da música para filtro. Exemplo: 123 */
  id?: InputMaybe<Scalars['Int']>;
  /** Quantidade de itens por página. Exemplo: 10 */
  limit: Scalars['Int'];
  /** Número da página para paginação. Exemplo: 1 */
  page: Scalars['Int'];
  /** ID do status da música para filtro. Exemplo: 2 */
  status_id?: InputMaybe<Scalars['Int']>;
  /** Título da música para filtro. Exemplo: 'Minha Canção Sertaneja' */
  title: Scalars['String'];
};

/** Dados para consulta de múltiplas músicas de um usuário, permitindo filtros e paginação. */
export type FindManyMusicInput = {
  /** Data para filtro das músicas. Exemplo: '2024-06-01' */
  date?: InputMaybe<Scalars['String']>;
  /** ID da música para filtro. Exemplo: 123 */
  id?: InputMaybe<Scalars['Int']>;
  /** Quantidade de itens por página. Exemplo: 10 */
  limit: Scalars['Int'];
  /** Número da página para paginação. Exemplo: 1 */
  page: Scalars['Int'];
  /** ID do status da música para filtro. Exemplo: 2 */
  status_id?: InputMaybe<Scalars['Int']>;
  /** Título da música para filtro. Exemplo: 'Minha Canção Sertaneja' */
  title: Scalars['String'];
};

/** Resposta para consulta de múltiplas músicas, incluindo links e estilos associados. */
export type FindManyMusicResponse = {
  __typename?: 'FindManyMusicResponse';
  certificates: Array<Certificate>;
  co_author?: Maybe<Scalars['JSON']>;
  created_at?: Maybe<Scalars['DateTime']>;
  files?: Maybe<File>;
  generic_enums?: Maybe<GenericEnum>;
  id: Scalars['ID'];
  interpreter?: Maybe<Scalars['JSON']>;
  key: Scalars['String'];
  letter: Scalars['JSON'];
  /** Link para download do áudio da música. Exemplo: 'https://exemplo.com/audio.mp3' */
  linkAudio?: Maybe<Scalars['String']>;
  /** Link para o certificado da música. Exemplo: 'https://exemplo.com/certificado.pdf' */
  linkCertificate?: Maybe<Scalars['String']>;
  /** Link para streaming da música. Exemplo: 'https://exemplo.com/stream.mp3' */
  linkStream?: Maybe<Scalars['String']>;
  music_file_id?: Maybe<Scalars['Float']>;
  musical_playlist: Array<MusicalPlaylist>;
  musical_styles: Array<MusicalStyle>;
  score?: Maybe<Scalars['Float']>;
  status_id?: Maybe<Scalars['Float']>;
  /** Lista de estilos musicais associados à música. Exemplo: [{ id: 1, name: 'Sertanejo' }] */
  styles?: Maybe<Array<Styles>>;
  title: Scalars['String'];
  updated_at?: Maybe<Scalars['DateTime']>;
  users?: Maybe<User>;
};

/** Posição e pontuação do usuário autenticado no ranking de um período específico. Retornado pela query findMyRankingByPeriod. */
export type FindMyRankingByPeriodResponse = {
  __typename?: 'FindMyRankingByPeriodResponse';
  /** Posição do usuário no ranking do período */
  position: Scalars['Int'];
  /** Pontuação do usuário no período (músicas + créditos comprados) */
  score: Scalars['Int'];
};

export type FindNfseInput = {
  date_end?: InputMaybe<Scalars['String']>;
  date_start?: InputMaybe<Scalars['String']>;
  limit?: Scalars['Int'];
  page?: Scalars['Int'];
  search?: InputMaybe<Scalars['String']>;
  status_id?: InputMaybe<Scalars['Int']>;
};

export type FindOneUserInput = {
  __typename?: 'FindOneUserInput';
  avatar?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  id: Scalars['Int'];
  is_active: Scalars['Boolean'];
  key: Scalars['String'];
  music: Array<Music>;
  nickname: Scalars['String'];
  password: Scalars['String'];
  persons?: Maybe<PersonInput>;
  ranking?: Maybe<RankingInput>;
  roles: Array<Scalars['String']>;
  terms: Scalars['String'];
  wallets?: Maybe<WalletInput>;
};

/** Item do ranking com dados do usuário e sua posição. Retornado pela query findRanking. */
export type FindRankingResponse = {
  __typename?: 'FindRankingResponse';
  /** ID do arquivo de avatar do usuário. Nulo caso não possua */
  avartar_id?: Maybe<Scalars['Int']>;
  /** URL do avatar do usuário. Nulo caso o usuário não possua avatar cadastrado */
  avatarUrl?: Maybe<Scalars['String']>;
  /** Data de criação do cadastro do usuário */
  created_at?: Maybe<Scalars['DateTime']>;
  /** Total de créditos utilizados pelo usuário */
  creditUsed: Scalars['Int'];
  /** Nome completo do usuário cadastrado na ficha. Exemplo: 'João Batista Oliveira Jales' */
  fullname: Scalars['String'];
  /** Identificador único (UUID) do usuário */
  key: Scalars['String'];
  /** Nome artístico do usuário. Exemplo: 'João Jales' */
  nickname: Scalars['String'];
  /** Quantidade de músicas com status COMPLETE cadastradas */
  qtdmusic: Scalars['Int'];
  /** Dados de pontuação e posição no ranking */
  ranking: RankingScoreItem;
};

export type ForgotPasswordEmailResponse = {
  __typename?: 'ForgotPasswordEmailResponse';
  message: Scalars['String'];
  title: Scalars['String'];
};

/** Dados necessários para solicitar recuperação de senha do usuário. */
export type ForgotPasswordUserInput = {
  /** E-mail do usuário para recuperação de senha. Exemplo: 'usuario@email.com' */
  email: Scalars['String'];
};

export type GenericEnum = {
  __typename?: 'GenericEnum';
  created_At?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  is_active?: Maybe<Scalars['Boolean']>;
  message: Array<Message>;
  music: Array<Music>;
  name: Scalars['String'];
  nfse: Array<Nfse>;
  orders: Array<Order>;
  payments_payments_payment_method_idTogeneric_enums: Array<Payment>;
  payments_payments_status_idTogeneric_enums: Array<Payment>;
  persons: Array<Person>;
  transactions: Array<Transaction>;
  type: Scalars['String'];
  updated_at?: Maybe<Scalars['DateTime']>;
  value: Scalars['String'];
};

export type GetPixChargeDto = {
  __typename?: 'GetPixChargeDto';
  calendario: Scalars['JSON'];
  chave: Scalars['String'];
  devedor?: Maybe<Scalars['JSON']>;
  infoAdicionais?: Maybe<Array<Scalars['JSON']>>;
  loc?: Maybe<Scalars['JSON']>;
  location?: Maybe<Scalars['String']>;
  pix?: Maybe<Array<Scalars['JSON']>>;
  pixCopiaECola?: Maybe<Scalars['String']>;
  revisao: Scalars['Float'];
  solicitacaoPagador?: Maybe<Scalars['String']>;
  status: Scalars['String'];
  txid: Scalars['String'];
  valor: Scalars['JSON'];
};

export type GetSicrediTokenResponseDto = {
  __typename?: 'GetSicrediTokenResponseDto';
  access_token: Scalars['String'];
  expires_in: Scalars['Float'];
  jti: Scalars['String'];
  scope: Scalars['String'];
  token_type: Scalars['String'];
};

/** Resposta da inicialização do PDF via BrySign, contendo dados da operação e informações dos certificados. */
export type InitPdfResponse = {
  __typename?: 'InitPdfResponse';
  /** Lista de informações dos certificados utilizados na operação. */
  certsInfo: Array<CertsInfo>;
  /** Dados da resposta de inicialização do BrySign para o PDF. */
  data: BrysignInitResponse;
};

/** Informações de um intérprete ou coautor. */
export type InterpreterOrCoauthor = {
  /** CPF do indivíduo. Exemplo: '12345678900' */
  cpf: Scalars['String'];
  /** ID do indivíduo. Exemplo: 1 */
  id: Scalars['Int'];
  /** Nome do indivíduo. Exemplo: 'João Silva' */
  name: Scalars['String'];
};

export type Invitation = {
  __typename?: 'Invitation';
  created_At?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  key_friend: Scalars['String'];
  score: Scalars['Float'];
  updated_at?: Maybe<Scalars['DateTime']>;
  users?: Maybe<User>;
  validated: Scalars['Boolean'];
};

export type Items = {
  product_id: Scalars['Float'];
  quantity: Scalars['Float'];
};

/** Informações de cada link associado ao documento assinado. */
export type LinkType = {
  __typename?: 'LinkType';
  /** URL do link para acesso ao documento assinado. Exemplo: 'https://exemplo.com/download/musica-assinada.pdf' */
  href: Scalars['String'];
  /** Tipo do link (relacionamento). Exemplo: 'download' */
  rel: Scalars['String'];
};

/** Resposta de erro ao tentar realizar login do usuário. */
export type LoginErrorResponse = {
  __typename?: 'LoginErrorResponse';
  /** Mensagem de erro informando o motivo da falha no login. Exemplo: 'Usuário ou senha inválidos.' */
  message: Scalars['String'];
};

/** Resposta de sucesso ao realizar login do usuário. */
export type LoginSuccessResponse = {
  __typename?: 'LoginSuccessResponse';
  /** Token de acesso gerado após o login. Exemplo: 'eyJhbGciOiJIUzI1NiIsInR5cCI6...' */
  accessToken: Scalars['String'];
  /** Mensagem de sucesso informando que o login foi realizado com sucesso. Exemplo: 'Login realizado com sucesso!' */
  message: Scalars['String'];
  /** Token de atualização para renovar o acesso. Exemplo: 'eyJhbGciOiJIUzI1NiIsInR5cCI6...' */
  refreshToken: Scalars['String'];
  /** Tipo de token utilizado para autenticação. Exemplo: 'bearer' */
  type: Scalars['String'];
  /** Dados do usuário autenticado após o login bem-sucedido. */
  user: UserConfirmed;
};

/** Dados necessários para autenticação do usuário. */
export type LoginUserInput = {
  /** E-mail do usuário. Exemplo: 'usuario@email.com' */
  email: Scalars['String'];
  /** Senha do usuário. Exemplo: 'minhaSenhaSegura123' */
  password: Scalars['String'];
};

export type LoginUserResponseUnion = LoginErrorResponse | LoginSuccessResponse;

export type Message = {
  __typename?: 'Message';
  created_At?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  generic_enums?: Maybe<GenericEnum>;
  id: Scalars['ID'];
  identifier: Scalars['String'];
  is_active: Scalars['Boolean'];
  messagem_body?: Maybe<Scalars['JSON']>;
  name: Scalars['String'];
  type_message_id?: Maybe<Scalars['Float']>;
  updated_at?: Maybe<Scalars['DateTime']>;
};

export type Meta = {
  __typename?: 'Meta';
  bonusCredit: Scalars['Float'];
  qty_items?: Maybe<Scalars['Float']>;
  subtotal?: Maybe<Scalars['String']>;
  totalCredits?: Maybe<Scalars['Float']>;
  totalScore: Scalars['Float'];
};

export type Music = {
  __typename?: 'Music';
  certificates: Array<Certificate>;
  co_author?: Maybe<Scalars['JSON']>;
  created_at?: Maybe<Scalars['DateTime']>;
  files?: Maybe<File>;
  generic_enums?: Maybe<GenericEnum>;
  id: Scalars['ID'];
  interpreter?: Maybe<Scalars['JSON']>;
  key: Scalars['String'];
  letter: Scalars['JSON'];
  music_file_id?: Maybe<Scalars['Float']>;
  musical_playlist: Array<MusicalPlaylist>;
  musical_styles: Array<MusicalStyle>;
  score?: Maybe<Scalars['Float']>;
  status_id?: Maybe<Scalars['Float']>;
  title: Scalars['String'];
  updated_at?: Maybe<Scalars['DateTime']>;
  users?: Maybe<User>;
};

/** Resposta detalhada dos contatos e certificado de uma música. */
export type MusicContactsCertificateResponse = {
  __typename?: 'MusicContactsCertificateResponse';
  /** Link para download do áudio da música. Exemplo: 'https://exemplo.com/audio.mp3' */
  linkAudio?: Maybe<Scalars['String']>;
  /** Link para o certificado da música. Exemplo: 'https://exemplo.com/certificado.pdf' */
  linkCertificate?: Maybe<Scalars['String']>;
  /** Link para streaming da música. Exemplo: 'https://exemplo.com/stream.mp3' */
  linkStream?: Maybe<Scalars['String']>;
  /** Informações da música. */
  music: Music;
  /** Informações do perfil do contato relacionado à música. */
  profile: Profile;
  /** Lista de estilos musicais associados à música. Exemplo: [{ id: 1, name: 'Sertanejo' }] */
  styles?: Maybe<Array<Styles>>;
};

export type MusicalPlaylist = {
  __typename?: 'MusicalPlaylist';
  id: Scalars['ID'];
  music: Music;
  playlist: Playlist;
};

export type MusicalStyle = {
  __typename?: 'MusicalStyle';
  categories?: Maybe<Categories>;
  id: Scalars['ID'];
  music: Music;
};

export type Mutation = {
  __typename?: 'Mutation';
  cancelNfse: Scalars['Boolean'];
  /** Altera a senha utilizando o token de recuperação. Exemplo de uso: { token: 'abc123token', password: 'senhaNova123' } */
  changeForgotPasswordByToken: Scalars['String'];
  /** Altera a senha do usuário autenticado. Exemplo de uso: { password: 'senhaAntiga123', newPassword: 'senhaNova456' } */
  changePassword: Scalars['String'];
  /** Confirma o cadastro do usuário. Exemplo de uso: { tokenId: 'abc123token' } */
  confirmUser: ConfirmUserResponseInput;
  createBillet: CreateChargeResponseDto;
  createCreditCard: CreateChargeResponseDto;
  /** Cria uma nova música no sistema. Exemplo de uso: { data: { title: 'Minha Canção Sertaneja', styles: 76, letter: ['Primeira linha', 'Segunda linha'], co_author: [{ id: 2, name: 'Maria', cpf: '09876543211' }], interpreter: [{ id: 1, name: 'João', cpf: '12345678900' }] } } */
  createMusic: Scalars['Float'];
  createNfse: Scalars['Boolean'];
  createPixCharge: CreateChargeResponseDto;
  /** Cria um novo usuário no sistema. Exemplo de uso: { email: 'usuario@email.com', password: 'senhaSegura123', nickname: 'Rafa123', contact: '85999999999', terms: true } */
  createUser: Scalars['String'];
  /** Delete um usuário pelo ID. Exemplo de uso: { id: 1 } */
  deleteUser: Scalars['String'];
  downloadNfse: Scalars['Boolean'];
  /** Envia e-mail para recuperação de senha. Exemplo de uso: { email: 'usuario@email.com' } */
  forgotPasswordEmail: ForgotPasswordEmailResponse;
  /** Inicializa o processo de assinatura PDF PADES via BrySign. Exemplo de uso: { data: { certificate: 'MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8A...', musicIds: [1, 2, 3] } } */
  initPdfBrysign: InitPdfResponse;
  /** Realiza o login do usuário. Exemplo de uso: { email: 'usuario@email.com', password: 'minhaSenhaSegura123' } */
  login: LoginUserResponseUnion;
  /** Realiza o logout do usuário autenticado removendo todas as instâncias de tokens do usuário. O token deve ser enviado no header Authorization. Exemplo de uso: Authorization: Bearer <token> */
  logout: Scalars['Boolean'];
  /** Envia e-mail de confirmação de cadastro. Exemplo de uso: { email: 'teste@registreacordeon.com.br' } */
  resendEmailConfirmation: Scalars['String'];
  resendNfseEmail: Scalars['Boolean'];
  /** Realiza a assinatura CADES das músicas via BrySign. Exemplo de uso: { data: { music_ids: [1, 2, 3] } } */
  signCadesBrysign: Array<Scalars['String']>;
  /** Solicita assinatura de certificados via Certisign. Exemplo de uso: { data: { music_ids: [1, 2, 3] } } */
  signCertificateCertisign: Scalars['String'];
  /** Realiza a assinatura PDF PADES via BrySign. Exemplo de uso: { data: { ... } } */
  signPdfBrysign: SignPdfResponse;
  /** Atualiza uma música existente. Exemplo de uso: { data: { musicId: 42, title: 'Minha Canção Atualizada', styles: 76, letter: ['Nova linha da letra'], co_author: [{ id: 2, name: 'Maria', cpf: '09876543211' }], interpreter: [{ id: 1, name: 'João', cpf: '12345678900' }] } } */
  updateMusic: Scalars['Float'];
  /** Atualiza o perfil do usuário autenticado. Exemplo de uso: { userData: { email: 'usuario@email.com', nickname: 'Rafa123' }, personData: {...}, addressData: {...}, contactData: {...} } */
  updateUserProfile: Scalars['String'];
  /** Atualiza o perfil de um usuário pelo ID (admin, gestor ou operador). Exemplo de uso: { id: 1, data: { userData: { email: 'usuario@email.com', nickname: 'Rafa123' }, personData: {...}, addressData: {...}, contactData: {...} } } */
  updateUserProfileByAdmin: Scalars['String'];
  /** Valida a assinatura de um documento. Exemplo de uso: { data: { hashAcordeon: 'a1b2c3d4e5f6...' } } */
  validateSignature: ValidateSignatureResponse;
  /** Verifica o token de recuperação de senha. Exemplo de uso: { tokenId: 'abc123token' } */
  verifyForgotPasswordToken: Scalars['String'];
  /** Verifica o token de autenticação do usuário. O token deve ser enviado no header Authorization. Exemplo de uso: Authorization: Bearer <token> */
  verifyToken: LoginUserResponseUnion;
};


export type MutationCancelNfseArgs = {
  transactionId: Scalars['String'];
};


export type MutationChangeForgotPasswordByTokenArgs = {
  data: ChangeForgotPasswordByTokenInput;
};


export type MutationChangePasswordArgs = {
  data: ChangePasswordInput;
};


export type MutationConfirmUserArgs = {
  data: ConfirmUserInput;
};


export type MutationCreateBilletArgs = {
  CreateChargeInput: CreateChargeInput;
};


export type MutationCreateCreditCardArgs = {
  CreateChargeInput: CreateChargeInput;
};


export type MutationCreateMusicArgs = {
  data: CreateMusicInput;
};


export type MutationCreateNfseArgs = {
  transaction_id: Scalars['String'];
};


export type MutationCreatePixChargeArgs = {
  CreateChargeInput: CreateChargeInput;
};


export type MutationCreateUserArgs = {
  data: CreateUserInput;
};


export type MutationDeleteUserArgs = {
  id: Scalars['Float'];
};


export type MutationDownloadNfseArgs = {
  transaction_id: Scalars['String'];
};


export type MutationForgotPasswordEmailArgs = {
  data: ForgotPasswordUserInput;
};


export type MutationInitPdfBrysignArgs = {
  data: CreateInitPadesInput;
};


export type MutationLoginArgs = {
  data: LoginUserInput;
};


export type MutationResendEmailConfirmationArgs = {
  email: Scalars['String'];
};


export type MutationResendNfseEmailArgs = {
  transactionId: Scalars['String'];
};


export type MutationSignCadesBrysignArgs = {
  data: BrysignSignatureCadesInput;
};


export type MutationSignCertificateCertisignArgs = {
  data: SignCertificatesCertisignInput;
};


export type MutationSignPdfBrysignArgs = {
  data: BrysignSignPdfPadesInput;
};


export type MutationUpdateMusicArgs = {
  data: UpdateMusicInput;
};


export type MutationUpdateUserProfileArgs = {
  data: UpdateProfileUserInput;
};


export type MutationUpdateUserProfileByAdminArgs = {
  data: UpdateProfileUserInput;
  id: Scalars['Float'];
};


export type MutationValidateSignatureArgs = {
  data: ValidateSignature;
};


export type MutationVerifyForgotPasswordTokenArgs = {
  data: ConfirmUserInput;
};

/** Objeto GraphQL que representa a entidade NFSe. */
export type Nfse = {
  __typename?: 'Nfse';
  /** Data de criação da NFSe (opcional). */
  created_at?: Maybe<Scalars['DateTime']>;
  /** Entidade de enumeração genérica relacionada (opcional). */
  generic_enums?: Maybe<GenericEnum>;
  /** Identificador único da NFSe. */
  id: Scalars['ID'];
  /** Chave única da NFSe. */
  nfseKey: Scalars['String'];
  /** Código de status da NFSe (opcional). */
  status?: Maybe<Scalars['Float']>;
  /** Referência para a transação relacionada (opcional). */
  transaction_id?: Maybe<Scalars['Float']>;
  /** Entidade de transação relacionada (opcional). */
  transactions?: Maybe<Transaction>;
  /** Data da última atualização da NFSe (opcional). */
  updated_at?: Maybe<Scalars['DateTime']>;
  /** URL para o PDF da NFSe (opcional). */
  url_pdf?: Maybe<Scalars['String']>;
  /** URL para o XML da NFSe (opcional). */
  url_xml?: Maybe<Scalars['String']>;
};

/** Resposta contendo dados paginados de NFSe. */
export type NfseResponseInput = {
  __typename?: 'NfseResponseInput';
  /** Lista de notas fiscais de serviço eletrônicas (NFSe) retornadas na consulta. */
  data: Array<Nfse>;
  /** Quantidade máxima de registros por página. */
  limit: Scalars['Int'];
  /** Número da página atual dos resultados. */
  page: Scalars['Int'];
  /** Quantidade total de registros encontrados. */
  total: Scalars['Int'];
  /** Quantidade total de páginas disponíveis. */
  totalPages: Scalars['Int'];
};

export type Order = {
  __typename?: 'Order';
  created_at?: Maybe<Scalars['DateTime']>;
  finished: Scalars['Boolean'];
  generic_enums?: Maybe<GenericEnum>;
  id: Scalars['ID'];
  key: Scalars['String'];
  order_items: Array<OrderItems>;
  payments?: Maybe<Array<Payment>>;
  status_id?: Maybe<Scalars['Float']>;
  total: Scalars['Float'];
  updated_at?: Maybe<Scalars['DateTime']>;
  users?: Maybe<User>;
  vouchers?: Maybe<Voucher>;
};

export type OrderItems = {
  __typename?: 'OrderItems';
  id: Scalars['ID'];
  orders?: Maybe<Order>;
  products?: Maybe<Product>;
  quantity?: Maybe<Scalars['Float']>;
  subtotal?: Maybe<Scalars['Float']>;
};

export type PasswordReset = {
  __typename?: 'PasswordReset';
  created_At?: Maybe<Scalars['DateTime']>;
  email: Scalars['String'];
  expires_at?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  token: Scalars['String'];
  updated_at?: Maybe<Scalars['DateTime']>;
  users: User;
};

export type Payment = {
  __typename?: 'Payment';
  amount?: Maybe<Scalars['Float']>;
  created_at?: Maybe<Scalars['DateTime']>;
  currency: Scalars['String'];
  generic_enums_payments_payment_method_idTogeneric_enums?: Maybe<GenericEnum>;
  generic_enums_payments_status_idTogeneric_enums?: Maybe<GenericEnum>;
  id: Scalars['ID'];
  ip?: Maybe<Scalars['String']>;
  key: Scalars['String'];
  orders?: Maybe<Order>;
  payment_method_id?: Maybe<Scalars['Float']>;
  status_id?: Maybe<Scalars['Float']>;
  transactions?: Maybe<Array<Transaction>>;
  updated_at?: Maybe<Scalars['DateTime']>;
};

export type PaymentOutput = {
  __typename?: 'PaymentOutput';
  amount: Scalars['Float'];
  created_at?: Maybe<Scalars['String']>;
  payment_method_id: Scalars['Float'];
  transaction: TransactionOutput;
};

export type Permission = {
  __typename?: 'Permission';
  created_At?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  permission_role: Array<PermissionRole>;
  permission_user: Array<PermissionUser>;
  slug: Scalars['String'];
  updated_at?: Maybe<Scalars['DateTime']>;
};

export type PermissionRole = {
  __typename?: 'PermissionRole';
  created_At?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  permissions?: Maybe<Permission>;
  roles?: Maybe<Role>;
  updated_at?: Maybe<Scalars['DateTime']>;
};

export type PermissionUser = {
  __typename?: 'PermissionUser';
  created_At?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  permissions?: Maybe<Permission>;
  updated_at?: Maybe<Scalars['DateTime']>;
  users?: Maybe<User>;
};

export type Person = {
  __typename?: 'Person';
  addresses: Array<Address>;
  birthday?: Maybe<Scalars['DateTime']>;
  contacts: Array<Contact>;
  cpf: Scalars['String'];
  created_At?: Maybe<Scalars['DateTime']>;
  fullname: Scalars['String'];
  gender_id: Scalars['Float'];
  generic_enums: GenericEnum;
  id: Scalars['ID'];
  rg?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  users?: Maybe<User>;
};

export type PersonInput = {
  __typename?: 'PersonInput';
  addresses: Array<AddressInput>;
  birthday?: Maybe<Scalars['DateTime']>;
  contacts: Array<ContactInput>;
  cpf: Scalars['String'];
  created_at: Scalars['DateTime'];
  fullname: Scalars['String'];
  gender_id: Scalars['Int'];
  id: Scalars['Int'];
  rg?: Maybe<Scalars['String']>;
  updated_at: Scalars['DateTime'];
};

export type Playlist = {
  __typename?: 'Playlist';
  created_At?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  is_active?: Maybe<Scalars['Boolean']>;
  key: Scalars['String'];
  musical_playlist: Array<MusicalPlaylist>;
  score?: Maybe<Scalars['Float']>;
  title: Scalars['String'];
  updated_at?: Maybe<Scalars['DateTime']>;
  users: User;
};

export type Product = {
  __typename?: 'Product';
  bonus: Array<Bonus>;
  code: Scalars['String'];
  created_At?: Maybe<Scalars['DateTime']>;
  credit: Scalars['Float'];
  description: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
  order_items: Array<OrderItems>;
  price: Scalars['Float'];
  score: Scalars['Float'];
  updated_at?: Maybe<Scalars['DateTime']>;
};

/** Resposta contendo informações de contatos, certificado e links relacionados à música. */
export type Profile = {
  __typename?: 'Profile';
  /** URL do avatar do contato. Exemplo: 'https://exemplo.com/avatar.jpg' */
  avatar?: Maybe<Scalars['String']>;
  /** E-mail do contato. Exemplo: 'joao@email.com' */
  email: Scalars['String'];
  /** Nome do contato. Exemplo: 'João Silva' */
  name: Scalars['String'];
  /** Telefone do contato. Exemplo: '+5585999999999' */
  phone: Scalars['String'];
};

/** Dados para atualização do perfil do usuário. */
export type ProfileUserInput = {
  /** E-mail do usuário. Exemplo: 'usuario@email.com' */
  email: Scalars['String'];
  /** Apelido do usuário. Exemplo: 'Rafa123' */
  nickname: Scalars['String'];
};

export type Query = {
  __typename?: 'Query';
  _service: _Service;
  /** Consulta todas as músicas do sistema com filtros e paginação. Exemplo de uso: { data: { title: 'Minha Canção Sertaneja', page: 1, limit: 10 } } */
  findAllMusics: Array<FindManyMusicResponse>;
  findAllNfse: NfseResponseInput;
  findAllOrders: Array<Order>;
  findAllUsers: Array<User>;
  /** Retorna todos os estilos musicais disponíveis para cadastro de músicas. */
  findMusicStyles: Array<Categories>;
  findMyNfse: NfseResponseInput;
  /** Retorna a posição e pontuação do usuário autenticado no ranking de um período específico. Lança NotFoundException caso o usuário não tenha pontuado no período. Exemplo de uso: query { findMyRankingByPeriod(startDate: "2025-04-15", endDate: "2025-05-31") { position score } } */
  findMyRankingByPeriod: FindMyRankingByPeriodResponse;
  findNfseById: Nfse;
  findNfseByIdAdmin: Nfse;
  findOneUser: FindOneUserInput;
  /** Retorna a lista de usuários no ranking geral, ordenada de forma decrescente pela pontuação total acumulada. Exemplo de uso: query { findRanking(limit: 20) { key nickname fullname creditUsed avartar_id created_at qtdmusic ranking { score pastPosition position } avatarUrl } } */
  findRanking: Array<FindRankingResponse>;
  /** Retorna o ranking de usuários considerando somente os pontos ganhos dentro de um período específico. Exemplo de uso: query { findRankingByPeriod(startDate: "2025-04-15", endDate: "2025-05-31", limit: 20) { key nickname fullname ranking { score position } avatarUrl } } */
  findRankingByPeriod: Array<FindRankingResponse>;
  /** Consulta todas as músicas de um usuário autenticado com filtros e paginação. Exemplo de uso: { data: { title: 'Minha Canção Sertaneja', page: 1, limit: 10, date: '2024-06-01' } } */
  findUserMusics: Array<FindManyMusicResponse>;
  getPixCharge: GetPixChargeDto;
  getSicrediToken: GetSicrediTokenResponseDto;
  sendBilletEmail: Scalars['Boolean'];
  /** Exibe detalhes de uma música, incluindo contatos e certificado. Exemplo de uso: { data: 'chaveDaMusica123' } */
  showMusicDetails: MusicContactsCertificateResponse;
};


export type QueryFindAllMusicsArgs = {
  data: FindManyMusicAdminInput;
};


export type QueryFindAllNfseArgs = {
  filters: FindNfseInput;
};


export type QueryFindAllOrdersArgs = {
  filters: FindNfseInput;
};


export type QueryFindAllUsersArgs = {
  artistic_name?: InputMaybe<Scalars['String']>;
  complete_registration?: InputMaybe<Scalars['Boolean']>;
  cpf?: InputMaybe<Scalars['String']>;
  date?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  has_available_credit?: InputMaybe<Scalars['Boolean']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  limit: Scalars['Float'];
  name?: InputMaybe<Scalars['String']>;
  page: Scalars['Float'];
  phone?: InputMaybe<Scalars['String']>;
};


export type QueryFindMyNfseArgs = {
  filters: FindNfseInput;
};


export type QueryFindMyRankingByPeriodArgs = {
  endDate: Scalars['String'];
  startDate: Scalars['String'];
};


export type QueryFindNfseByIdArgs = {
  id: Scalars['Int'];
};


export type QueryFindNfseByIdAdminArgs = {
  id: Scalars['Int'];
};


export type QueryFindRankingArgs = {
  limit?: InputMaybe<Scalars['Int']>;
};


export type QueryFindRankingByPeriodArgs = {
  endDate: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  startDate: Scalars['String'];
};


export type QueryFindUserMusicsArgs = {
  data: FindManyMusicInput;
};


export type QueryGetPixChargeArgs = {
  txId: Scalars['String'];
};


export type QuerySendBilletEmailArgs = {
  orderKey: Scalars['String'];
};


export type QueryShowMusicDetailsArgs = {
  data: Scalars['String'];
};

export type Ranking = {
  __typename?: 'Ranking';
  created_At?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  ranking_history: Array<RankingHistory>;
  score: Scalars['Float'];
  updated_at?: Maybe<Scalars['DateTime']>;
  users?: Maybe<User>;
};

export type RankingHistory = {
  __typename?: 'RankingHistory';
  created_At?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  ranking: Ranking;
  score: Scalars['Float'];
  updated_at?: Maybe<Scalars['DateTime']>;
  user_id: Scalars['Float'];
};

export type RankingHistoryInput = {
  __typename?: 'RankingHistoryInput';
  created_at: Scalars['DateTime'];
  id: Scalars['Int'];
  score: Scalars['Float'];
  updated_at: Scalars['DateTime'];
  user_id: Scalars['Int'];
};

export type RankingInput = {
  __typename?: 'RankingInput';
  created_at: Scalars['DateTime'];
  id: Scalars['Int'];
  position: Scalars['Int'];
  ranking_history: Array<RankingHistoryInput>;
  score: Scalars['Float'];
  updated_at?: Maybe<Scalars['DateTime']>;
};

/** Pontuação e posição do usuário no ranking. Exemplo: { score: 286, pastPosition: 0, position: 1 } */
export type RankingScoreItem = {
  __typename?: 'RankingScoreItem';
  /** Posição anterior do usuário no ranking. Atualmente retorna 0 (histórico não implementado) */
  pastPosition: Scalars['Int'];
  /** Posição atual do usuário no ranking */
  position: Scalars['Int'];
  /** Pontuação do usuário no ranking */
  score: Scalars['Int'];
};

export type Role = {
  __typename?: 'Role';
  created_At?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  permission_role: Array<PermissionRole>;
  role_user: Array<RoleUser>;
  slug: Scalars['String'];
  updated_at?: Maybe<Scalars['DateTime']>;
};

export type RoleUser = {
  __typename?: 'RoleUser';
  created_At?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  roles?: Maybe<Role>;
  updated_at?: Maybe<Scalars['DateTime']>;
  users?: Maybe<User>;
};

/** Dados necessários para solicitar assinatura de certificados via Certisign. */
export type SignCertificatesCertisignInput = {
  /** Lista de IDs das músicas para assinatura. Exemplo: [1, 2, 3] */
  music_ids: Array<Scalars['Int']>;
};

/** Resposta da assinatura PDF PADES via BrySign, contendo identificador, quantidade de assinaturas e documentos assinados. */
export type SignPdfResponse = {
  __typename?: 'SignPdfResponse';
  /** Lista de documentos assinados na operação. */
  documentos: Array<DocumentosType>;
  /** Identificador da operação de assinatura. Exemplo: 'op123456' */
  identificador: Scalars['String'];
  /** Quantidade de assinaturas realizadas. Exemplo: 2 */
  quantidadeAssinaturas: Scalars['Int'];
};

export type Styles = {
  __typename?: 'Styles';
  /** ID da categoria do estilo musical. Exemplo: 5 */
  category_id: Scalars['Int'];
  /** ID do estilo musical. Exemplo: 1 */
  id: Scalars['Int'];
  /** ID da música associada ao estilo. Exemplo: 123 */
  music_id: Scalars['Int'];
};

export type Token = {
  __typename?: 'Token';
  created_At?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  is_revoked?: Maybe<Scalars['Boolean']>;
  token: Scalars['String'];
  type: Scalars['String'];
  updated_at?: Maybe<Scalars['DateTime']>;
  users?: Maybe<User>;
};

export type Transaction = {
  __typename?: 'Transaction';
  authorization_code?: Maybe<Scalars['String']>;
  authorized_amount?: Maybe<Scalars['Float']>;
  boleto_barcode?: Maybe<Scalars['String']>;
  boleto_expiration_date?: Maybe<Scalars['String']>;
  boleto_url?: Maybe<Scalars['String']>;
  brand?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['DateTime']>;
  fingerprint?: Maybe<Scalars['String']>;
  generic_enums?: Maybe<GenericEnum>;
  id: Scalars['ID'];
  installments?: Maybe<Scalars['Float']>;
  nfse?: Maybe<Nfse>;
  payments?: Maybe<Payment>;
  status_id?: Maybe<Scalars['Float']>;
  transaction_id: Scalars['String'];
  updated_at?: Maybe<Scalars['DateTime']>;
};

export type TransactionOutput = {
  __typename?: 'TransactionOutput';
  authorized_amount: Scalars['Float'];
  boleto_barcode?: Maybe<Scalars['String']>;
  boleto_expiration_date?: Maybe<Scalars['String']>;
  boleto_url?: Maybe<Scalars['String']>;
  brand?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['String']>;
  fingerprint?: Maybe<Scalars['String']>;
  installments?: Maybe<Scalars['Float']>;
  transaction_id: Scalars['String'];
};

/** Dados necessários para atualizar um endereço existente. */
export type UpdateAddressInput = {
  /** Cidade do endereço. Exemplo: 'Fortaleza' */
  city: Scalars['String'];
  /** Complemento do endereço. Exemplo: 'Apto 101' */
  complement?: InputMaybe<Scalars['String']>;
  /** País do endereço. Exemplo: 'Brasil' */
  country: Scalars['String'];
  /** Bairro do endereço. Exemplo: 'Centro' */
  neighborhood: Scalars['String'];
  /** Estado do endereço. Exemplo: 'CE' */
  state: Scalars['String'];
  /** Nome da rua. Exemplo: 'Rua das Flores' */
  street: Scalars['String'];
  /** Número da residência. Exemplo: '123' */
  street_number: Scalars['String'];
  /** CEP do endereço. Exemplo: '60170-010' */
  zipcode: Scalars['String'];
};

/** Dados necessários para atualizar um contato existente. */
export type UpdateContactInput = {
  /** Nova informação de contato. Exemplo: '85988887777' */
  contact: Scalars['String'];
};

/** Dados necessários para atualizar uma música existente. */
export type UpdateMusicInput = {
  /** ID do usuário administrador responsável pela atualização. Exemplo: 1 */
  adminUserId?: InputMaybe<Scalars['Int']>;
  /** Informações do(s) coautor(es) da música. Exemplo: [{ id: 2, name: 'Maria', cpf: '09876543211' }] */
  co_author?: InputMaybe<Scalars['JSON']>;
  /** Informações do(s) intérprete(s) da música. Exemplo: [{ id: 1, name: 'João', cpf: '12345678900' }] */
  interpreter?: InputMaybe<Scalars['JSON']>;
  /** Letra da música em formato JSON. Exemplo: ['Primeira linha', 'Segunda linha'] */
  letter: Scalars['JSON'];
  /** ID da música a ser atualizada. Exemplo: 42 */
  musicId: Scalars['Int'];
  /** ID do arquivo de música associado. Exemplo: 123 */
  music_file_id?: InputMaybe<Scalars['Int']>;
  /** ID do estilo musical. Exemplo: 76 */
  styles: Scalars['Int'];
  /** Título da música. Exemplo: 'Minha Canção Atualizada' */
  title: Scalars['String'];
};

/** Dados necessários para atualizar uma pessoa existente. */
export type UpdatePersonInput = {
  /** Data de nascimento da pessoa. Exemplo: '1990-05-20' */
  birthday: Scalars['String'];
  /** CPF da pessoa. Exemplo: '12345678900' */
  cpf: Scalars['String'];
  /** Nome completo da pessoa. Exemplo: 'João da Silva' */
  fullname: Scalars['String'];
  /** ID do gênero da pessoa. Exemplo: 2 */
  gender_id: Scalars['Int'];
  /** RG da pessoa. Exemplo: 'MG1234567' */
  rg?: InputMaybe<Scalars['String']>;
};

/** Input para atualizar o perfil completo do usuário, incluindo dados pessoais, endereço e contato. */
export type UpdateProfileUserInput = {
  /** Endereço do usuário para atualização. */
  addressData: UpdateAddressInput;
  /** Contato do usuário para atualização. */
  contactData: UpdateContactInput;
  /** Dados pessoais do usuário para atualização. */
  personData: UpdatePersonInput;
  /** Dados básicos do usuário para atualização. */
  userData: ProfileUserInput;
};

export type User = {
  __typename?: 'User';
  avatar?: Maybe<Scalars['String']>;
  comments: Array<Comment>;
  created_at?: Maybe<Scalars['DateTime']>;
  credit_cards: Array<CreditCard>;
  email: Scalars['String'];
  files: Array<File>;
  id: Scalars['ID'];
  invitations: Array<Invitation>;
  is_active: Scalars['Boolean'];
  key: Scalars['String'];
  music: Array<Music>;
  nickname: Scalars['String'];
  orders: Array<Order>;
  password: Scalars['String'];
  password_resets: Array<PasswordReset>;
  permission_user: Array<PermissionUser>;
  persons: Array<Person>;
  playlist: Array<Playlist>;
  ranking?: Maybe<Array<Ranking>>;
  role_user: Array<RoleUser>;
  terms: Scalars['Boolean'];
  tokens: Array<Token>;
  updated_at?: Maybe<Scalars['DateTime']>;
  wallets: Array<Wallet>;
};

/** Informações do usuário confirmado. */
export type UserConfirmed = {
  __typename?: 'UserConfirmed';
  /** URL do avatar do usuário, se disponível. */
  avatar?: Maybe<Scalars['String']>;
  /** Data de criação do usuário. */
  created_at: Scalars['DateTime'];
  /** E-mail do usuário confirmado. */
  email: Scalars['String'];
  /** Indica se o usuário está ativo. */
  is_active: Scalars['Boolean'];
  /** Chave única do usuário confirmado. */
  key: Scalars['String'];
  /** Apelido do usuário confirmado. */
  nickname: Scalars['String'];
};

/** Dados necessários para validar a assinatura de um documento. */
export type ValidateSignature = {
  /** Hash do documento para validação da assinatura. Exemplo: 'a1b2c3d4e5f6...' */
  hashAcordeon: Scalars['String'];
};

/** Resposta da validação da assinatura de um documento, contendo links e arquivos relacionados. */
export type ValidateSignatureResponse = {
  __typename?: 'ValidateSignatureResponse';
  /** Arquivo do certificado gerado. Exemplo: 'certificado.pdf' */
  fileCertificate: Scalars['String'];
  /** Arquivo de música gerado, se disponível. Exemplo: 'musica.mp3' */
  fileMusic?: Maybe<Scalars['String']>;
  /** Link para o arquivo P7S, se disponível. Exemplo: 'https://exemplo.com/arquivo.p7s' */
  linkFileP7s?: Maybe<Scalars['String']>;
  /** Link para o arquivo ITI. Exemplo: 'https://exemplo.com/arquivo.iti' */
  linkITI: Scalars['String'];
  /** Link para download ou visualização da música. Exemplo: 'https://exemplo.com/musica.mp3' */
  linkMusic: Scalars['String'];
};

export type Video = {
  __typename?: 'Video';
  created_At?: Maybe<Scalars['DateTime']>;
  files?: Maybe<File>;
  id: Scalars['ID'];
  is_active: Scalars['Boolean'];
  key: Scalars['String'];
  overview?: Maybe<Scalars['String']>;
  poster_file_id?: Maybe<Scalars['Float']>;
  title: Scalars['String'];
  updated_at?: Maybe<Scalars['DateTime']>;
  video_path: Scalars['String'];
  videos_genres: Array<VideoGenre>;
};

export type VideoGenre = {
  __typename?: 'VideoGenre';
  categories?: Maybe<Categories>;
  created_At?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  updated_at?: Maybe<Scalars['DateTime']>;
  videos?: Maybe<Video>;
};

export type Voucher = {
  __typename?: 'Voucher';
  code?: Maybe<Scalars['String']>;
  created_At?: Maybe<Scalars['DateTime']>;
  credit?: Maybe<Scalars['Float']>;
  description?: Maybe<Scalars['String']>;
  expiration?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  is_active: Scalars['Boolean'];
  key: Scalars['String'];
  limit?: Maybe<Scalars['Float']>;
  orders: Array<Order>;
  updated_at?: Maybe<Scalars['DateTime']>;
};

export type Wallet = {
  __typename?: 'Wallet';
  amount: Scalars['Float'];
  created_at?: Maybe<Scalars['DateTime']>;
  creditTotal: Scalars['Float'];
  creditUsed: Scalars['Float'];
  customer_asaas?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  scoreUsed: Scalars['Float'];
  updated_at?: Maybe<Scalars['DateTime']>;
  users: Array<User>;
  wallet_history: Array<WalletHistory>;
};

export type WalletHistory = {
  __typename?: 'WalletHistory';
  action: Scalars['String'];
  amount: Scalars['Float'];
  created_At?: Maybe<Scalars['DateTime']>;
  creditTotal: Scalars['Float'];
  creditUser: Scalars['Float'];
  id: Scalars['ID'];
  scoreUser: Scalars['Float'];
  updated_at?: Maybe<Scalars['DateTime']>;
  user_id: Scalars['Float'];
  wallets: Wallet;
};

export type WalletInput = {
  __typename?: 'WalletInput';
  amount: Scalars['Float'];
  created_at: Scalars['DateTime'];
  creditTotal: Scalars['Float'];
  creditUsed: Scalars['Float'];
  customer_asaas: Scalars['String'];
  id: Scalars['Int'];
  scoreUsed: Scalars['Float'];
  updated_at: Scalars['DateTime'];
};

export type _Service = {
  __typename?: '_Service';
  /** The sdl representing the federated service capabilities. Includes federation directives, removes federation types, and includes rest of full schema after schema directives have been applied */
  sdl?: Maybe<Scalars['String']>;
};

export type ChangeForgotPasswordByTokenMutationVariables = Exact<{
  data: ChangeForgotPasswordByTokenInput;
}>;


export type ChangeForgotPasswordByTokenMutation = { __typename?: 'Mutation', changeForgotPasswordByToken: string };

export type ConfirmUserMutationVariables = Exact<{
  data: ConfirmUserInput;
}>;


export type ConfirmUserMutation = { __typename?: 'Mutation', confirmUser: { __typename?: 'ConfirmUserResponseInput', message: string, user: { __typename?: 'UserConfirmed', key: string, email: string, nickname: string, is_active: boolean, created_at: any, avatar?: string | null } } };

export type CreateBilletMutationVariables = Exact<{
  createChargeInput: CreateChargeInput;
}>;


export type CreateBilletMutation = { __typename?: 'Mutation', createBillet: { __typename?: 'CreateChargeResponseDto', key: string, total?: string | null, status_id?: number | null, charge: any, created_at?: string | null, payment?: { __typename?: 'PaymentOutput', transaction: { __typename?: 'TransactionOutput', authorized_amount: number, boleto_url?: string | null, boleto_barcode?: string | null, boleto_expiration_date?: string | null } } | null, meta?: { __typename?: 'Meta', qty_items?: number | null, subtotal?: string | null, totalCredits?: number | null, totalScore: number } | null } };

export type CreateCreditCardMutationVariables = Exact<{
  createChargeInput: CreateChargeInput;
}>;


export type CreateCreditCardMutation = { __typename?: 'Mutation', createCreditCard: { __typename?: 'CreateChargeResponseDto', key: string, total?: string | null, charge: any, created_at?: string | null, status_id?: number | null, payment?: { __typename?: 'PaymentOutput', transaction: { __typename?: 'TransactionOutput', authorized_amount: number, brand?: string | null, installments?: number | null } } | null, meta?: { __typename?: 'Meta', qty_items?: number | null, subtotal?: string | null, totalCredits?: number | null, totalScore: number } | null } };

export type CreateMusicMutationVariables = Exact<{
  data: CreateMusicInput;
}>;


export type CreateMusicMutation = { __typename?: 'Mutation', createMusic: number };

export type CreatePixChargeMutationVariables = Exact<{
  createChargeInput: CreateChargeInput;
}>;


export type CreatePixChargeMutation = { __typename?: 'Mutation', createPixCharge: { __typename?: 'CreateChargeResponseDto', charge: any, created_at?: string | null, status_id?: number | null, total?: string | null, meta?: { __typename?: 'Meta', qty_items?: number | null, subtotal?: string | null, totalCredits?: number | null, totalScore: number } | null, payment?: { __typename?: 'PaymentOutput', payment_method_id: number, transaction: { __typename?: 'TransactionOutput', transaction_id: string } } | null } };

export type CreateUserMutationVariables = Exact<{
  data: CreateUserInput;
}>;


export type CreateUserMutation = { __typename?: 'Mutation', createUser: string };

export type ForgotPasswordEmailMutationVariables = Exact<{
  data: ForgotPasswordUserInput;
}>;


export type ForgotPasswordEmailMutation = { __typename?: 'Mutation', forgotPasswordEmail: { __typename?: 'ForgotPasswordEmailResponse', title: string, message: string } };

export type LoginMutationVariables = Exact<{
  data: LoginUserInput;
}>;


export type LoginMutation = { __typename?: 'Mutation', login: { __typename?: 'LoginErrorResponse', message: string } | { __typename?: 'LoginSuccessResponse', message: string, type: string, accessToken: string, refreshToken: string, user: { __typename?: 'UserConfirmed', key: string, email: string, nickname: string, is_active: boolean, created_at: any, avatar?: string | null } } };

export type LogoutMutationVariables = Exact<{ [key: string]: never; }>;


export type LogoutMutation = { __typename?: 'Mutation', logout: boolean };

export type UpdateUserProfileMutationVariables = Exact<{
  data: UpdateProfileUserInput;
}>;


export type UpdateUserProfileMutation = { __typename?: 'Mutation', updateUserProfile: string };

export type ValidateSignatureMutationVariables = Exact<{
  data: ValidateSignature;
}>;


export type ValidateSignatureMutation = { __typename?: 'Mutation', validateSignature: { __typename?: 'ValidateSignatureResponse', fileCertificate: string, fileMusic?: string | null, linkFileP7s?: string | null, linkITI: string, linkMusic: string } };

export type VerifyForgotPasswordTokenMutationVariables = Exact<{
  data: ConfirmUserInput;
}>;


export type VerifyForgotPasswordTokenMutation = { __typename?: 'Mutation', verifyForgotPasswordToken: string };

export type VerifyTokenMutationVariables = Exact<{ [key: string]: never; }>;


export type VerifyTokenMutation = { __typename?: 'Mutation', verifyToken: { __typename?: 'LoginErrorResponse', message: string } | { __typename?: 'LoginSuccessResponse', accessToken: string, refreshToken: string } };

export type FindMusicStylesQueryVariables = Exact<{ [key: string]: never; }>;


export type FindMusicStylesQuery = { __typename?: 'Query', findMusicStyles: Array<{ __typename?: 'Categories', id: string, name: string, description?: string | null }> };

export type FindMyRankingByPeriodQueryVariables = Exact<{
  startDate: Scalars['String'];
  endDate: Scalars['String'];
}>;


export type FindMyRankingByPeriodQuery = { __typename?: 'Query', findMyRankingByPeriod: { __typename?: 'FindMyRankingByPeriodResponse', position: number, score: number } };

export type FindOneUserQueryVariables = Exact<{ [key: string]: never; }>;


export type FindOneUserQuery = { __typename?: 'Query', findOneUser: { __typename?: 'FindOneUserInput', id: number, key: string, email: string, password: string, nickname: string, is_active: boolean, avatar?: string | null, roles: Array<string>, persons?: { __typename?: 'PersonInput', id: number, fullname: string, cpf: string, rg?: string | null, birthday?: any | null, gender_id: number, addresses: Array<{ __typename?: 'AddressInput', id: number, zipcode: string, street: string, street_number: string, complement: string, neighborhood: string, city: string, state: string, country: string }>, contacts: Array<{ __typename?: 'ContactInput', id: number, name: string, number: string }> } | null, ranking?: { __typename?: 'RankingInput', id: number, score: number, position: number } | null, wallets?: { __typename?: 'WalletInput', scoreUsed: number, creditUsed: number, creditTotal: number, amount: number, id: number } | null } };

export type FindRankingQueryVariables = Exact<{ [key: string]: never; }>;


export type FindRankingQuery = { __typename?: 'Query', findRanking: Array<{ __typename?: 'FindRankingResponse', key: string, nickname: string, fullname: string, creditUsed: number, avartar_id?: number | null, created_at?: any | null, qtdmusic: number, avatarUrl?: string | null, ranking: { __typename?: 'RankingScoreItem', score: number, pastPosition: number, position: number } }> };

export type FindRankingByPeriodQueryVariables = Exact<{
  startDate: Scalars['String'];
  endDate: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type FindRankingByPeriodQuery = { __typename?: 'Query', findRankingByPeriod: Array<{ __typename?: 'FindRankingResponse', key: string, nickname: string, fullname: string, creditUsed: number, avartar_id?: number | null, created_at?: any | null, qtdmusic: number, avatarUrl?: string | null, ranking: { __typename?: 'RankingScoreItem', score: number, pastPosition: number, position: number } }> };

export type FindUserMusicsQueryVariables = Exact<{
  data: FindManyMusicInput;
}>;


export type FindUserMusicsQuery = { __typename?: 'Query', findUserMusics: Array<{ __typename?: 'FindManyMusicResponse', id: string, created_at?: any | null, key: string, co_author?: any | null, interpreter?: any | null, title: string, letter: any, status_id?: number | null, linkAudio?: string | null, linkCertificate?: string | null, linkStream?: string | null, files?: { __typename?: 'File', extension?: string | null } | null }> };

export type GetPixChargeQueryVariables = Exact<{
  txId: Scalars['String'];
}>;


export type GetPixChargeQuery = { __typename?: 'Query', getPixCharge: { __typename?: 'GetPixChargeDto', valor: any, calendario: any, chave: string, devedor?: any | null, infoAdicionais?: Array<any> | null, loc?: any | null, location?: string | null, pix?: Array<any> | null, pixCopiaECola?: string | null, status: string } };

export type SendBilletEmailQueryVariables = Exact<{
  orderKey: Scalars['String'];
}>;


export type SendBilletEmailQuery = { __typename?: 'Query', sendBilletEmail: boolean };

export type ShowMusicDetailsQueryVariables = Exact<{
  data: Scalars['String'];
}>;


export type ShowMusicDetailsQuery = { __typename?: 'Query', showMusicDetails: { __typename?: 'MusicContactsCertificateResponse', linkAudio?: string | null, music: { __typename?: 'Music', id: string, key: string, title: string, letter: any, interpreter?: any | null, co_author?: any | null, certificates: Array<{ __typename?: 'Certificate', created_At?: any | null, signUrl?: string | null }>, files?: { __typename?: 'File', extension?: string | null } | null }, profile: { __typename?: 'Profile', name: string, email: string, phone: string, avatar?: string | null } } };


export const ChangeForgotPasswordByTokenDocument = gql`
    mutation ChangeForgotPasswordByToken($data: ChangeForgotPasswordByTokenInput!) {
  changeForgotPasswordByToken(data: $data)
}
    `;
export type ChangeForgotPasswordByTokenMutationFn = Apollo.MutationFunction<ChangeForgotPasswordByTokenMutation, ChangeForgotPasswordByTokenMutationVariables>;

/**
 * __useChangeForgotPasswordByTokenMutation__
 *
 * To run a mutation, you first call `useChangeForgotPasswordByTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeForgotPasswordByTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeForgotPasswordByTokenMutation, { data, loading, error }] = useChangeForgotPasswordByTokenMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useChangeForgotPasswordByTokenMutation(baseOptions?: Apollo.MutationHookOptions<ChangeForgotPasswordByTokenMutation, ChangeForgotPasswordByTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangeForgotPasswordByTokenMutation, ChangeForgotPasswordByTokenMutationVariables>(ChangeForgotPasswordByTokenDocument, options);
      }
export type ChangeForgotPasswordByTokenMutationHookResult = ReturnType<typeof useChangeForgotPasswordByTokenMutation>;
export type ChangeForgotPasswordByTokenMutationResult = Apollo.MutationResult<ChangeForgotPasswordByTokenMutation>;
export type ChangeForgotPasswordByTokenMutationOptions = Apollo.BaseMutationOptions<ChangeForgotPasswordByTokenMutation, ChangeForgotPasswordByTokenMutationVariables>;
export const ConfirmUserDocument = gql`
    mutation ConfirmUser($data: ConfirmUserInput!) {
  confirmUser(data: $data) {
    user {
      key
      email
      nickname
      is_active
      created_at
      avatar
    }
    message
  }
}
    `;
export type ConfirmUserMutationFn = Apollo.MutationFunction<ConfirmUserMutation, ConfirmUserMutationVariables>;

/**
 * __useConfirmUserMutation__
 *
 * To run a mutation, you first call `useConfirmUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmUserMutation, { data, loading, error }] = useConfirmUserMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useConfirmUserMutation(baseOptions?: Apollo.MutationHookOptions<ConfirmUserMutation, ConfirmUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConfirmUserMutation, ConfirmUserMutationVariables>(ConfirmUserDocument, options);
      }
export type ConfirmUserMutationHookResult = ReturnType<typeof useConfirmUserMutation>;
export type ConfirmUserMutationResult = Apollo.MutationResult<ConfirmUserMutation>;
export type ConfirmUserMutationOptions = Apollo.BaseMutationOptions<ConfirmUserMutation, ConfirmUserMutationVariables>;
export const CreateBilletDocument = gql`
    mutation CreateBillet($createChargeInput: CreateChargeInput!) {
  createBillet(CreateChargeInput: $createChargeInput) {
    key
    total
    payment {
      transaction {
        authorized_amount
        boleto_url
        boleto_barcode
        boleto_expiration_date
      }
    }
    status_id
    meta {
      qty_items
      subtotal
      totalCredits
      totalScore
    }
    charge
    created_at
  }
}
    `;
export type CreateBilletMutationFn = Apollo.MutationFunction<CreateBilletMutation, CreateBilletMutationVariables>;

/**
 * __useCreateBilletMutation__
 *
 * To run a mutation, you first call `useCreateBilletMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBilletMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBilletMutation, { data, loading, error }] = useCreateBilletMutation({
 *   variables: {
 *      createChargeInput: // value for 'createChargeInput'
 *   },
 * });
 */
export function useCreateBilletMutation(baseOptions?: Apollo.MutationHookOptions<CreateBilletMutation, CreateBilletMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateBilletMutation, CreateBilletMutationVariables>(CreateBilletDocument, options);
      }
export type CreateBilletMutationHookResult = ReturnType<typeof useCreateBilletMutation>;
export type CreateBilletMutationResult = Apollo.MutationResult<CreateBilletMutation>;
export type CreateBilletMutationOptions = Apollo.BaseMutationOptions<CreateBilletMutation, CreateBilletMutationVariables>;
export const CreateCreditCardDocument = gql`
    mutation CreateCreditCard($createChargeInput: CreateChargeInput!) {
  createCreditCard(CreateChargeInput: $createChargeInput) {
    key
    total
    charge
    payment {
      transaction {
        authorized_amount
        brand
        installments
      }
    }
    meta {
      qty_items
      subtotal
      totalCredits
      totalScore
    }
    created_at
    status_id
  }
}
    `;
export type CreateCreditCardMutationFn = Apollo.MutationFunction<CreateCreditCardMutation, CreateCreditCardMutationVariables>;

/**
 * __useCreateCreditCardMutation__
 *
 * To run a mutation, you first call `useCreateCreditCardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCreditCardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCreditCardMutation, { data, loading, error }] = useCreateCreditCardMutation({
 *   variables: {
 *      createChargeInput: // value for 'createChargeInput'
 *   },
 * });
 */
export function useCreateCreditCardMutation(baseOptions?: Apollo.MutationHookOptions<CreateCreditCardMutation, CreateCreditCardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCreditCardMutation, CreateCreditCardMutationVariables>(CreateCreditCardDocument, options);
      }
export type CreateCreditCardMutationHookResult = ReturnType<typeof useCreateCreditCardMutation>;
export type CreateCreditCardMutationResult = Apollo.MutationResult<CreateCreditCardMutation>;
export type CreateCreditCardMutationOptions = Apollo.BaseMutationOptions<CreateCreditCardMutation, CreateCreditCardMutationVariables>;
export const CreateMusicDocument = gql`
    mutation CreateMusic($data: CreateMusicInput!) {
  createMusic(data: $data)
}
    `;
export type CreateMusicMutationFn = Apollo.MutationFunction<CreateMusicMutation, CreateMusicMutationVariables>;

/**
 * __useCreateMusicMutation__
 *
 * To run a mutation, you first call `useCreateMusicMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMusicMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMusicMutation, { data, loading, error }] = useCreateMusicMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateMusicMutation(baseOptions?: Apollo.MutationHookOptions<CreateMusicMutation, CreateMusicMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMusicMutation, CreateMusicMutationVariables>(CreateMusicDocument, options);
      }
export type CreateMusicMutationHookResult = ReturnType<typeof useCreateMusicMutation>;
export type CreateMusicMutationResult = Apollo.MutationResult<CreateMusicMutation>;
export type CreateMusicMutationOptions = Apollo.BaseMutationOptions<CreateMusicMutation, CreateMusicMutationVariables>;
export const CreatePixChargeDocument = gql`
    mutation CreatePixCharge($createChargeInput: CreateChargeInput!) {
  createPixCharge(CreateChargeInput: $createChargeInput) {
    meta {
      qty_items
      subtotal
      totalCredits
      totalScore
    }
    charge
    created_at
    payment {
      transaction {
        transaction_id
      }
      payment_method_id
    }
    status_id
    total
  }
}
    `;
export type CreatePixChargeMutationFn = Apollo.MutationFunction<CreatePixChargeMutation, CreatePixChargeMutationVariables>;

/**
 * __useCreatePixChargeMutation__
 *
 * To run a mutation, you first call `useCreatePixChargeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePixChargeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPixChargeMutation, { data, loading, error }] = useCreatePixChargeMutation({
 *   variables: {
 *      createChargeInput: // value for 'createChargeInput'
 *   },
 * });
 */
export function useCreatePixChargeMutation(baseOptions?: Apollo.MutationHookOptions<CreatePixChargeMutation, CreatePixChargeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePixChargeMutation, CreatePixChargeMutationVariables>(CreatePixChargeDocument, options);
      }
export type CreatePixChargeMutationHookResult = ReturnType<typeof useCreatePixChargeMutation>;
export type CreatePixChargeMutationResult = Apollo.MutationResult<CreatePixChargeMutation>;
export type CreatePixChargeMutationOptions = Apollo.BaseMutationOptions<CreatePixChargeMutation, CreatePixChargeMutationVariables>;
export const CreateUserDocument = gql`
    mutation CreateUser($data: CreateUserInput!) {
  createUser(data: $data)
}
    `;
export type CreateUserMutationFn = Apollo.MutationFunction<CreateUserMutation, CreateUserMutationVariables>;

/**
 * __useCreateUserMutation__
 *
 * To run a mutation, you first call `useCreateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserMutation, { data, loading, error }] = useCreateUserMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateUserMutation(baseOptions?: Apollo.MutationHookOptions<CreateUserMutation, CreateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUserMutation, CreateUserMutationVariables>(CreateUserDocument, options);
      }
export type CreateUserMutationHookResult = ReturnType<typeof useCreateUserMutation>;
export type CreateUserMutationResult = Apollo.MutationResult<CreateUserMutation>;
export type CreateUserMutationOptions = Apollo.BaseMutationOptions<CreateUserMutation, CreateUserMutationVariables>;
export const ForgotPasswordEmailDocument = gql`
    mutation ForgotPasswordEmail($data: ForgotPasswordUserInput!) {
  forgotPasswordEmail(data: $data) {
    title
    message
  }
}
    `;
export type ForgotPasswordEmailMutationFn = Apollo.MutationFunction<ForgotPasswordEmailMutation, ForgotPasswordEmailMutationVariables>;

/**
 * __useForgotPasswordEmailMutation__
 *
 * To run a mutation, you first call `useForgotPasswordEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useForgotPasswordEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [forgotPasswordEmailMutation, { data, loading, error }] = useForgotPasswordEmailMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useForgotPasswordEmailMutation(baseOptions?: Apollo.MutationHookOptions<ForgotPasswordEmailMutation, ForgotPasswordEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ForgotPasswordEmailMutation, ForgotPasswordEmailMutationVariables>(ForgotPasswordEmailDocument, options);
      }
export type ForgotPasswordEmailMutationHookResult = ReturnType<typeof useForgotPasswordEmailMutation>;
export type ForgotPasswordEmailMutationResult = Apollo.MutationResult<ForgotPasswordEmailMutation>;
export type ForgotPasswordEmailMutationOptions = Apollo.BaseMutationOptions<ForgotPasswordEmailMutation, ForgotPasswordEmailMutationVariables>;
export const LoginDocument = gql`
    mutation Login($data: LoginUserInput!) {
  login(data: $data) {
    ... on LoginSuccessResponse {
      message
      type
      accessToken
      refreshToken
      user {
        key
        email
        nickname
        is_active
        created_at
        avatar
      }
    }
    ... on LoginErrorResponse {
      message
    }
  }
}
    `;
export type LoginMutationFn = Apollo.MutationFunction<LoginMutation, LoginMutationVariables>;

/**
 * __useLoginMutation__
 *
 * To run a mutation, you first call `useLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginMutation, { data, loading, error }] = useLoginMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useLoginMutation(baseOptions?: Apollo.MutationHookOptions<LoginMutation, LoginMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LoginMutation, LoginMutationVariables>(LoginDocument, options);
      }
export type LoginMutationHookResult = ReturnType<typeof useLoginMutation>;
export type LoginMutationResult = Apollo.MutationResult<LoginMutation>;
export type LoginMutationOptions = Apollo.BaseMutationOptions<LoginMutation, LoginMutationVariables>;
export const LogoutDocument = gql`
    mutation Logout {
  logout
}
    `;
export type LogoutMutationFn = Apollo.MutationFunction<LogoutMutation, LogoutMutationVariables>;

/**
 * __useLogoutMutation__
 *
 * To run a mutation, you first call `useLogoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLogoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [logoutMutation, { data, loading, error }] = useLogoutMutation({
 *   variables: {
 *   },
 * });
 */
export function useLogoutMutation(baseOptions?: Apollo.MutationHookOptions<LogoutMutation, LogoutMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LogoutMutation, LogoutMutationVariables>(LogoutDocument, options);
      }
export type LogoutMutationHookResult = ReturnType<typeof useLogoutMutation>;
export type LogoutMutationResult = Apollo.MutationResult<LogoutMutation>;
export type LogoutMutationOptions = Apollo.BaseMutationOptions<LogoutMutation, LogoutMutationVariables>;
export const UpdateUserProfileDocument = gql`
    mutation UpdateUserProfile($data: UpdateProfileUserInput!) {
  updateUserProfile(data: $data)
}
    `;
export type UpdateUserProfileMutationFn = Apollo.MutationFunction<UpdateUserProfileMutation, UpdateUserProfileMutationVariables>;

/**
 * __useUpdateUserProfileMutation__
 *
 * To run a mutation, you first call `useUpdateUserProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserProfileMutation, { data, loading, error }] = useUpdateUserProfileMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateUserProfileMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserProfileMutation, UpdateUserProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserProfileMutation, UpdateUserProfileMutationVariables>(UpdateUserProfileDocument, options);
      }
export type UpdateUserProfileMutationHookResult = ReturnType<typeof useUpdateUserProfileMutation>;
export type UpdateUserProfileMutationResult = Apollo.MutationResult<UpdateUserProfileMutation>;
export type UpdateUserProfileMutationOptions = Apollo.BaseMutationOptions<UpdateUserProfileMutation, UpdateUserProfileMutationVariables>;
export const ValidateSignatureDocument = gql`
    mutation ValidateSignature($data: ValidateSignature!) {
  validateSignature(data: $data) {
    fileCertificate
    fileMusic
    linkFileP7s
    linkITI
    linkMusic
  }
}
    `;
export type ValidateSignatureMutationFn = Apollo.MutationFunction<ValidateSignatureMutation, ValidateSignatureMutationVariables>;

/**
 * __useValidateSignatureMutation__
 *
 * To run a mutation, you first call `useValidateSignatureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useValidateSignatureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [validateSignatureMutation, { data, loading, error }] = useValidateSignatureMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useValidateSignatureMutation(baseOptions?: Apollo.MutationHookOptions<ValidateSignatureMutation, ValidateSignatureMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ValidateSignatureMutation, ValidateSignatureMutationVariables>(ValidateSignatureDocument, options);
      }
export type ValidateSignatureMutationHookResult = ReturnType<typeof useValidateSignatureMutation>;
export type ValidateSignatureMutationResult = Apollo.MutationResult<ValidateSignatureMutation>;
export type ValidateSignatureMutationOptions = Apollo.BaseMutationOptions<ValidateSignatureMutation, ValidateSignatureMutationVariables>;
export const VerifyForgotPasswordTokenDocument = gql`
    mutation VerifyForgotPasswordToken($data: ConfirmUserInput!) {
  verifyForgotPasswordToken(data: $data)
}
    `;
export type VerifyForgotPasswordTokenMutationFn = Apollo.MutationFunction<VerifyForgotPasswordTokenMutation, VerifyForgotPasswordTokenMutationVariables>;

/**
 * __useVerifyForgotPasswordTokenMutation__
 *
 * To run a mutation, you first call `useVerifyForgotPasswordTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyForgotPasswordTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyForgotPasswordTokenMutation, { data, loading, error }] = useVerifyForgotPasswordTokenMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useVerifyForgotPasswordTokenMutation(baseOptions?: Apollo.MutationHookOptions<VerifyForgotPasswordTokenMutation, VerifyForgotPasswordTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VerifyForgotPasswordTokenMutation, VerifyForgotPasswordTokenMutationVariables>(VerifyForgotPasswordTokenDocument, options);
      }
export type VerifyForgotPasswordTokenMutationHookResult = ReturnType<typeof useVerifyForgotPasswordTokenMutation>;
export type VerifyForgotPasswordTokenMutationResult = Apollo.MutationResult<VerifyForgotPasswordTokenMutation>;
export type VerifyForgotPasswordTokenMutationOptions = Apollo.BaseMutationOptions<VerifyForgotPasswordTokenMutation, VerifyForgotPasswordTokenMutationVariables>;
export const VerifyTokenDocument = gql`
    mutation VerifyToken {
  verifyToken {
    ... on LoginSuccessResponse {
      accessToken
      refreshToken
    }
    ... on LoginErrorResponse {
      message
    }
  }
}
    `;
export type VerifyTokenMutationFn = Apollo.MutationFunction<VerifyTokenMutation, VerifyTokenMutationVariables>;

/**
 * __useVerifyTokenMutation__
 *
 * To run a mutation, you first call `useVerifyTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyTokenMutation, { data, loading, error }] = useVerifyTokenMutation({
 *   variables: {
 *   },
 * });
 */
export function useVerifyTokenMutation(baseOptions?: Apollo.MutationHookOptions<VerifyTokenMutation, VerifyTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VerifyTokenMutation, VerifyTokenMutationVariables>(VerifyTokenDocument, options);
      }
export type VerifyTokenMutationHookResult = ReturnType<typeof useVerifyTokenMutation>;
export type VerifyTokenMutationResult = Apollo.MutationResult<VerifyTokenMutation>;
export type VerifyTokenMutationOptions = Apollo.BaseMutationOptions<VerifyTokenMutation, VerifyTokenMutationVariables>;
export const FindMusicStylesDocument = gql`
    query FindMusicStyles {
  findMusicStyles {
    id
    name
    description
  }
}
    `;

/**
 * __useFindMusicStylesQuery__
 *
 * To run a query within a React component, call `useFindMusicStylesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindMusicStylesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindMusicStylesQuery({
 *   variables: {
 *   },
 * });
 */
export function useFindMusicStylesQuery(baseOptions?: Apollo.QueryHookOptions<FindMusicStylesQuery, FindMusicStylesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindMusicStylesQuery, FindMusicStylesQueryVariables>(FindMusicStylesDocument, options);
      }
export function useFindMusicStylesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindMusicStylesQuery, FindMusicStylesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindMusicStylesQuery, FindMusicStylesQueryVariables>(FindMusicStylesDocument, options);
        }
export type FindMusicStylesQueryHookResult = ReturnType<typeof useFindMusicStylesQuery>;
export type FindMusicStylesLazyQueryHookResult = ReturnType<typeof useFindMusicStylesLazyQuery>;
export type FindMusicStylesQueryResult = Apollo.QueryResult<FindMusicStylesQuery, FindMusicStylesQueryVariables>;
export const FindMyRankingByPeriodDocument = gql`
    query FindMyRankingByPeriod($startDate: String!, $endDate: String!) {
  findMyRankingByPeriod(startDate: $startDate, endDate: $endDate) {
    position
    score
  }
}
    `;

/**
 * __useFindMyRankingByPeriodQuery__
 *
 * To run a query within a React component, call `useFindMyRankingByPeriodQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindMyRankingByPeriodQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindMyRankingByPeriodQuery({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useFindMyRankingByPeriodQuery(baseOptions: Apollo.QueryHookOptions<FindMyRankingByPeriodQuery, FindMyRankingByPeriodQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindMyRankingByPeriodQuery, FindMyRankingByPeriodQueryVariables>(FindMyRankingByPeriodDocument, options);
      }
export function useFindMyRankingByPeriodLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindMyRankingByPeriodQuery, FindMyRankingByPeriodQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindMyRankingByPeriodQuery, FindMyRankingByPeriodQueryVariables>(FindMyRankingByPeriodDocument, options);
        }
export type FindMyRankingByPeriodQueryHookResult = ReturnType<typeof useFindMyRankingByPeriodQuery>;
export type FindMyRankingByPeriodLazyQueryHookResult = ReturnType<typeof useFindMyRankingByPeriodLazyQuery>;
export type FindMyRankingByPeriodQueryResult = Apollo.QueryResult<FindMyRankingByPeriodQuery, FindMyRankingByPeriodQueryVariables>;
export const FindOneUserDocument = gql`
    query FindOneUser {
  findOneUser {
    id
    key
    email
    password
    nickname
    is_active
    avatar
    persons {
      id
      fullname
      cpf
      rg
      birthday
      gender_id
      addresses {
        id
        zipcode
        street
        street_number
        complement
        neighborhood
        city
        state
        country
      }
      contacts {
        id
        name
        number
      }
    }
    ranking {
      id
      score
      position
    }
    roles
    wallets {
      scoreUsed
      creditUsed
      creditTotal
      amount
      id
    }
  }
}
    `;

/**
 * __useFindOneUserQuery__
 *
 * To run a query within a React component, call `useFindOneUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindOneUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindOneUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useFindOneUserQuery(baseOptions?: Apollo.QueryHookOptions<FindOneUserQuery, FindOneUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindOneUserQuery, FindOneUserQueryVariables>(FindOneUserDocument, options);
      }
export function useFindOneUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindOneUserQuery, FindOneUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindOneUserQuery, FindOneUserQueryVariables>(FindOneUserDocument, options);
        }
export type FindOneUserQueryHookResult = ReturnType<typeof useFindOneUserQuery>;
export type FindOneUserLazyQueryHookResult = ReturnType<typeof useFindOneUserLazyQuery>;
export type FindOneUserQueryResult = Apollo.QueryResult<FindOneUserQuery, FindOneUserQueryVariables>;
export const FindRankingDocument = gql`
    query FindRanking {
  findRanking {
    key
    nickname
    fullname
    ranking {
      score
      position
    }
    avatarUrl
  }
}
    `;

/**
 * __useFindRankingQuery__
 *
 * To run a query within a React component, call `useFindRankingQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindRankingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindRankingQuery({
 *   variables: {
 *   },
 * });
 */
export function useFindRankingQuery(baseOptions?: Apollo.QueryHookOptions<FindRankingQuery, FindRankingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindRankingQuery, FindRankingQueryVariables>(FindRankingDocument, options);
      }
export function useFindRankingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindRankingQuery, FindRankingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindRankingQuery, FindRankingQueryVariables>(FindRankingDocument, options);
        }
export type FindRankingQueryHookResult = ReturnType<typeof useFindRankingQuery>;
export type FindRankingLazyQueryHookResult = ReturnType<typeof useFindRankingLazyQuery>;
export type FindRankingQueryResult = Apollo.QueryResult<FindRankingQuery, FindRankingQueryVariables>;
export const FindRankingByPeriodDocument = gql`
    query FindRankingByPeriod($startDate: String!, $endDate: String!, $limit: Int) {
  findRankingByPeriod(startDate: $startDate, endDate: $endDate, limit: $limit) {
    key
    nickname
    fullname
    ranking {
      score
      position
    }
    avatarUrl
  }
}
    `;

/**
 * __useFindRankingByPeriodQuery__
 *
 * To run a query within a React component, call `useFindRankingByPeriodQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindRankingByPeriodQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindRankingByPeriodQuery({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useFindRankingByPeriodQuery(baseOptions: Apollo.QueryHookOptions<FindRankingByPeriodQuery, FindRankingByPeriodQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindRankingByPeriodQuery, FindRankingByPeriodQueryVariables>(FindRankingByPeriodDocument, options);
      }
export function useFindRankingByPeriodLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindRankingByPeriodQuery, FindRankingByPeriodQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindRankingByPeriodQuery, FindRankingByPeriodQueryVariables>(FindRankingByPeriodDocument, options);
        }
export type FindRankingByPeriodQueryHookResult = ReturnType<typeof useFindRankingByPeriodQuery>;
export type FindRankingByPeriodLazyQueryHookResult = ReturnType<typeof useFindRankingByPeriodLazyQuery>;
export type FindRankingByPeriodQueryResult = Apollo.QueryResult<FindRankingByPeriodQuery, FindRankingByPeriodQueryVariables>;
export const FindUserMusicsDocument = gql`
    query FindUserMusics($data: FindManyMusicInput!) {
  findUserMusics(data: $data) {
    id
    created_at
    key
    co_author
    interpreter
    title
    letter
    status_id
    linkAudio
    linkCertificate
    linkStream
    id
    key
    files {
      extension
    }
  }
}
    `;

/**
 * __useFindUserMusicsQuery__
 *
 * To run a query within a React component, call `useFindUserMusicsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindUserMusicsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindUserMusicsQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useFindUserMusicsQuery(baseOptions: Apollo.QueryHookOptions<FindUserMusicsQuery, FindUserMusicsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindUserMusicsQuery, FindUserMusicsQueryVariables>(FindUserMusicsDocument, options);
      }
export function useFindUserMusicsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindUserMusicsQuery, FindUserMusicsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindUserMusicsQuery, FindUserMusicsQueryVariables>(FindUserMusicsDocument, options);
        }
export type FindUserMusicsQueryHookResult = ReturnType<typeof useFindUserMusicsQuery>;
export type FindUserMusicsLazyQueryHookResult = ReturnType<typeof useFindUserMusicsLazyQuery>;
export type FindUserMusicsQueryResult = Apollo.QueryResult<FindUserMusicsQuery, FindUserMusicsQueryVariables>;
export const GetPixChargeDocument = gql`
    query GetPixCharge($txId: String!) {
  getPixCharge(txId: $txId) {
    valor
    calendario
    chave
    devedor
    infoAdicionais
    loc
    location
    pix
    pixCopiaECola
    status
  }
}
    `;

/**
 * __useGetPixChargeQuery__
 *
 * To run a query within a React component, call `useGetPixChargeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPixChargeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPixChargeQuery({
 *   variables: {
 *      txId: // value for 'txId'
 *   },
 * });
 */
export function useGetPixChargeQuery(baseOptions: Apollo.QueryHookOptions<GetPixChargeQuery, GetPixChargeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPixChargeQuery, GetPixChargeQueryVariables>(GetPixChargeDocument, options);
      }
export function useGetPixChargeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPixChargeQuery, GetPixChargeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPixChargeQuery, GetPixChargeQueryVariables>(GetPixChargeDocument, options);
        }
export type GetPixChargeQueryHookResult = ReturnType<typeof useGetPixChargeQuery>;
export type GetPixChargeLazyQueryHookResult = ReturnType<typeof useGetPixChargeLazyQuery>;
export type GetPixChargeQueryResult = Apollo.QueryResult<GetPixChargeQuery, GetPixChargeQueryVariables>;
export const SendBilletEmailDocument = gql`
    query SendBilletEmail($orderKey: String!) {
  sendBilletEmail(orderKey: $orderKey)
}
    `;

/**
 * __useSendBilletEmailQuery__
 *
 * To run a query within a React component, call `useSendBilletEmailQuery` and pass it any options that fit your needs.
 * When your component renders, `useSendBilletEmailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSendBilletEmailQuery({
 *   variables: {
 *      orderKey: // value for 'orderKey'
 *   },
 * });
 */
export function useSendBilletEmailQuery(baseOptions: Apollo.QueryHookOptions<SendBilletEmailQuery, SendBilletEmailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SendBilletEmailQuery, SendBilletEmailQueryVariables>(SendBilletEmailDocument, options);
      }
export function useSendBilletEmailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SendBilletEmailQuery, SendBilletEmailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SendBilletEmailQuery, SendBilletEmailQueryVariables>(SendBilletEmailDocument, options);
        }
export type SendBilletEmailQueryHookResult = ReturnType<typeof useSendBilletEmailQuery>;
export type SendBilletEmailLazyQueryHookResult = ReturnType<typeof useSendBilletEmailLazyQuery>;
export type SendBilletEmailQueryResult = Apollo.QueryResult<SendBilletEmailQuery, SendBilletEmailQueryVariables>;
export const ShowMusicDetailsDocument = gql`
    query ShowMusicDetails($data: String!) {
  showMusicDetails(data: $data) {
    linkAudio
    music {
      id
      key
      title
      letter
      interpreter
      co_author
      certificates {
        created_At
        signUrl
      }
      files {
        extension
      }
    }
    profile {
      name
      email
      phone
      avatar
    }
  }
}
    `;

/**
 * __useShowMusicDetailsQuery__
 *
 * To run a query within a React component, call `useShowMusicDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useShowMusicDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShowMusicDetailsQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useShowMusicDetailsQuery(baseOptions: Apollo.QueryHookOptions<ShowMusicDetailsQuery, ShowMusicDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ShowMusicDetailsQuery, ShowMusicDetailsQueryVariables>(ShowMusicDetailsDocument, options);
      }
export function useShowMusicDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ShowMusicDetailsQuery, ShowMusicDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ShowMusicDetailsQuery, ShowMusicDetailsQueryVariables>(ShowMusicDetailsDocument, options);
        }
export type ShowMusicDetailsQueryHookResult = ReturnType<typeof useShowMusicDetailsQuery>;
export type ShowMusicDetailsLazyQueryHookResult = ReturnType<typeof useShowMusicDetailsLazyQuery>;
export type ShowMusicDetailsQueryResult = Apollo.QueryResult<ShowMusicDetailsQuery, ShowMusicDetailsQueryVariables>;
